"use client";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import React from "react";

type UmrahAccordionProps = {
  value: string;
  label: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export const UmrahAccordion: React.FC<UmrahAccordionProps> = ({
  value,
  label,
  children,
  className,
  disabled = false,
}) => {
  return (
    <AccordionItem value={value} className={cn("", className)} disabled={disabled}>
      <AccordionTrigger className="px-4 py-2.5 font-semibold hover:no-underline">
        <span className="block truncate">{label}</span>
      </AccordionTrigger>
      <AccordionContent className="space-y-4 px-4 pt-3">{children}</AccordionContent>
    </AccordionItem>
  );
};
